import { render, staticRenderFns } from "./PaymentEdit.vue?vue&type=template&id=0835e654"
import script from "../../controllers/payment/payment-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment/payment-edit.js?vue&type=script&lang=js&external"
import style0 from "./PaymentEdit.vue?vue&type=style&index=0&id=0835e654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports